import {handleSend} from '../post'

const update604001 = (data) => {
  return handleSend(data, '60', '4001', data.operaType)
}

const list604002 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '4002')
}

const unitList604003 = (data) => {
  return handleSend(data, '60', '4003')
}

export const HxApiUnit = {
  update604001,
  list604002,
  unitList604003
}



// WEBPACK FOOTER //
// ./src/api/erp/info/unit.js